import React, { useState } from "react";
import { TimePicker } from "antd";
import dayjs from "dayjs";

const MaterialLikeTimePicker = ({ label, value, onChange, required, readOnly }) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className={`mui-input-container ${focused || value ? "focused" : ""}`}>
      <label className="mui-label">
        {/* {(focused || value) && required && <span className="required-star">*</span>} */}
        {required && <span className="required-star">*</span>}{label}
      </label>
      <TimePicker
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        use12Hours
        minuteStep={30}
        format="hh:mm A"
        style={{ width: "100%", height: "46px" }}
        needConfirm={false}
        readOnly={readOnly}
      />
      <span className="mui-underline" />
    </div>
  );
};

export default MaterialLikeTimePicker;
